<template>
	<div class="db2-zonemap">
		<div class="db2-zonemap-bar">
			<div class="title">{{ title }}</div>
			<div class="views">
				<button type="button" :class="{ on: view === 'map' }" @click="view = 'map'">Map</button>
				<button type="button" :class="{ on: view === 'grid' }" @click="view = 'grid'">Grid</button>
				<button type="button" :class="{ on: view === 'list' }" @click="view = 'list'">List</button>
			</div>
		</div>
		<div class="db2-zonemap-canvas" v-if="view !== 'list'">
			<div
				v-for="z in zones"
				:key="z.id"
				class="db2-zone-tile"
				:class="'is-' + z.status"
			>
				<div class="id">{{ z.id }}</div>
				<div>{{ z.temp }}°F</div>
				<div class="rh">{{ z.rh }}% RH</div>
			</div>
		</div>
		<div class="db2-zonemap-list" v-else>
			<div v-for="z in zones" :key="z.id" class="row">
				<strong>{{ z.id }}</strong>
				<span>{{ z.temp }}°F · {{ z.rh }}% RH</span>
				<em>{{ z.status }}</em>
			</div>
		</div>
		<div class="db2-zonemap-legend">
			<span class="is-excellent">Excellent</span>
			<span class="is-good">Good</span>
			<span class="is-fair">Fair</span>
			<span class="is-unoccupied">Unoccupied</span>
		</div>
		<div class="db2-zonemap-note">Preview only — live floor plans are not wired in v1.</div>
	</div>
</template>

<script>
import { mockZones } from '../mockPointData';

/**
 * Static zone-map preview (not a live floor plan).
 */
export default {
	name: 'ZoneMapCard',
	props: {
		card: { type: Object, required: true },
		timePeriod: { type: String, default: 'week' }
	},
	data() {
		return { view: 'map' };
	},
	computed: {
		/**
		 * Card title.
		 * @returns {string}
		 */
		title() {
			return (this.card.config && this.card.config.title) || this.card.name || 'Zone Map';
		},
		/**
		 * Mock zones.
		 * @returns {Array}
		 */
		zones() {
			return mockZones(this.card.uniqueId);
		}
	},
	created() {
		this.view = (this.card.config && this.card.config.view) || 'map';
	}
};
</script>
